{
  "Detailstitle": "Segmentdetails aufrufen",
  "Recordingtitle": "Anrufsegmentaufzeichnung",
  "Details": "Einzelheiten",
  "Recording": "Aufzeichnung",
  "Value": "Wert",
  "Collapseall": "Alle reduzieren",
  "FieldStatistic": "Feld \/ Statistik",
  "Calldatetimevalues": "Rufen Sie Datums-\/Uhrzeitwerte auf",
  "Deviceinformation": "Geräteinformation",
  "Calltypestatus": "Anruftyp und -status",
  "Callmovement": "Informationen zum Bewegungsszenario aufrufen",
  "Calldurationvalues": "Anrufdauerwerte",
  "Telephoneinformation": "Informationen zur Telefonnummer",
  "Acdinformation": "Informationen zum ACD-Agenten",
  "Associatedtelephonyenvironment": "Zugehörige Telefonieumgebung",
  "Diagnosticvalues": "Diagnosewerte",
  "Previous": "Vorherige",
  "Next": "Nächste",
  "Playrecording": "Aufnahme abspielen",
  "Errorplayrecording": "Abrufen der Aufzeichnung fehlgeschlagen",
  "Norecording": "Keine Aufnahme(n)",
  "Retrievingrecordings": "Aufzeichnungen abrufen...",
  "Backtodetails": "Zurück zu Details",
  "Segmentid": "Segmentketten-ID kopieren",
  "Copied": "Kopiert!",
  "Help": "Hilfe",
  "Close": "Nah dran",
  "RecordingTimeoutError": "Die maximale Anzahl an Versuchen, die Anrufaufzeichnungen für diesen Anruf abzurufen, wurde überschritten.",
  "EditableHint": "Klicken Sie auf die Beschreibung, um dieses Feld zu bearbeiten.",
  "EditPlaceholder": "Klicken Sie hier, um eine Beschreibung hinzuzufügen",
  "ReloadDataP1": "Ein Eintrag wurde kürzlich aktualisiert,",
  "ReloadDataP2": "Klick hier",
  "ReloadDataP3": "um die Daten neu zu laden.",
  "DescMaxLengthValidation": "Es gibt eine maximale Zeichenlänge von 100.",
  "ConfirmChange": "Bestätigen",
  "CancelChange": "Absagen",
  "NAME": "CallDetails",
  "AccountCodeHint": "Klicken Sie auf den Kontocode, um dieses Feld zu bearbeiten.",
  "AccountCodePlaceholder": "Klicken Sie hier, um den Kontocode hinzuzufügen",
  "DescriptionHint": "Klicken Sie auf die Beschreibung, um dieses Feld zu bearbeiten.",
  "DescriptionPlaceholder": "Klicken Sie hier, um eine Beschreibung hinzuzufügen",
  "NoAccountCodes": "Keine Kontocodes verfügbar",
  "First": "Erste",
  "Last": "Zuletzt",
  "CallJourneyTitle": "Anrufreise",
  "CallRecordingTitle": "Anrufaufzeichnung",
  "CallSegmentTitle": "Segment {} von {}",
  "TabTextTimeline": "Zeitleiste",
  "TabTextSegments": "Segmente",
  "TabTextRecording": "Aufnahme",
  "StatisticDeviceCalled": "Angerufener Name\/Nummer",
  "StatisticDeviceCalling": "Name\/Nummer des Anrufers",
  "StatisticTotalCallTime": "Gesamte Gesprächszeit",
  "StatisticStatus": "Status",
  "Answered": "Beantwortet",
  "NotAnswered": "Nicht beantwortet"
}